<template>
    <NavComponent class="has-bt-border" />
    <div class="sm:w-[945px] max-w-full w-full mx-auto">
        <div class="flex sm:flex-row flex-col justify-between block h-full sm:my-10 sm:gap-5">
            <section class="main_swiper_container sm:w-[56%] w-full">
                <div class="main_pc_tt sm:block hidden my-10 max-[850px]:bg-none">
                    <h1 class="font-bold text-white">우리들의 이야기</h1>
                    <h1 class="font-black text-neutral-800">슈라이프</h1>
                </div>

                <!-- 슬라이드 -->
                <div class="relative">
                    <swiper-container 
                        :autoplay="{delay: 10000}"
                        :navigation="{
                            prevEl: '.swiper-button-prev',
                            nextEl: '.swiper-button-next',
                        }"
                        @slidechange="set0"

                    >



                      <!-- 김명주 AI 시대의 나 
                      <swiper-slide class="sm:aspect-[200/241] overflow-y-hidden">
                        <router-link :to="'/view/special1/14'">
                          <img src="@/assets/slide/main_slide3.jpg" class="w-full"/>
                          <div class="main_slide_text absolute bottom-3 left-0 text-white sm:p-10 p-5 pb-12">
                              <h3>SWU SPECIAL</h3>
                              <h1 class="underline decoration-1 underline-offset-8">AI는 양심이 없다<br/>AI 시대의 나</h1>
                              <p class="mt-2"> 김명주 교수님(정보보호학과)</p>
                              <p class="mont mt-5 font-medium flex items-center gap-2">
                                VIEW
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30.5px" height="11.5px">
                                  <path fill-rule="evenodd"  stroke="rgb(255, 255, 255)" stroke-width="1px" stroke-linecap="butt" stroke-linejoin="miter" fill="none"
                                  d="M0.524,9.149 L27.746,9.149 L19.968,1.371 "/>
                                </svg>
                              </p>
                          </div>
                        </router-link>
                      </swiper-slide>  -->    
                      <!-- 임영신 공정여행가 특강 
                      <swiper-slide class="sm:aspect-[200/241] overflow-y-hidden">
                        <router-link :to="'/view/special1/13'">
                          <img src="@/assets/slide/main_slide2.jpg" class="w-full"/>
                          <div class="main_slide_text absolute bottom-3 left-0 text-white sm:p-10 p-5 pb-12">
                              <h3>SWU SPECIAL</h3>
                              <h1 class="underline decoration-1 underline-offset-8">여행, 세상의 지도를<br/>새롭게 그리다</h1>
                              <p class="mt-2">임영신 공정여행가</p>
                              <p class="mont mt-5 font-medium flex items-center gap-2">
                                VIEW
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30.5px" height="11.5px">
                                  <path fill-rule="evenodd"  stroke="rgb(255, 255, 255)" stroke-width="1px" stroke-linecap="butt" stroke-linejoin="miter" fill="none"
                                  d="M0.524,9.149 L27.746,9.149 L19.968,1.371 "/>
                                </svg>
                              </p>
                          </div>
                        </router-link>
                      </swiper-slide>-->
                      <!--임영신 공정여행가 특강 -->
                      <!--<swiper-slide class="sm:aspect-[200/241] overflow-y-hidden">
                        <router-link :to="'/view/special1/15'">
                          <img src="@/assets/slide/main_slide4.jpg" class="w-full"/>
                          <div class="main_slide_text absolute bottom-3 left-0 text-white sm:p-10 p-5 pb-12">
                              <h3>SWU SPECIAL</h3>
                              <h1 class="underline decoration-1 underline-offset-8">사람과 지구를 위로하는<br/>커피클레이</h1>
                              <p class="mt-2">고유미 대표</p>
                              <p class="mont mt-5 font-medium flex items-center gap-2">
                                VIEW
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30.5px" height="11.5px">
                                  <path fill-rule="evenodd"  stroke="rgb(255, 255, 255)" stroke-width="1px" stroke-linecap="butt" stroke-linejoin="miter" fill="none"
                                  d="M0.524,9.149 L27.746,9.149 L19.968,1.371 "/>
                                </svg>
                              </p>
                          </div>
                        </router-link>
                      </swiper-slide>-->
                      <swiper-slide class="sm:aspect-[200/241] overflow-y-hidden">
                        <router-link :to="'/view/barom1/2'">
                          <img src="@/assets/slide/main_slide6.jpg" class="w-full"/>
                          <div class="main_slide_text absolute bottom-3 left-0 text-white sm:p-10 p-5 pb-12">
                              <h3>바롬 ARCHIVE</h3>
                              <h1 class="underline decoration-1 underline-offset-8">바롬인성교육<br>우수사례</h1>
                          </div>
                        </router-link>
                      </swiper-slide>
                      <!-- 바롬인성교육 토론 활동-->
                      <swiper-slide class="sm:aspect-[200/241] overflow-y-hidden">
                        <router-link :to="'/list/bd1'">
                          <div class="main_slide_text absolute bottom-3 left-0 text-white sm:p-10 p-5 pb-12 z-50">
                            <h3>photo 이야기</h3>
                            <h1 class="underline decoration-1 underline-offset-8">바롬인성교육<br/>토론 활동</h1>
                          </div>
                          <video class="w-full" id="slideVid" autoplay muted="muted" loop playsinline>
                            <source src="@/assets/slide/slide_vid1.mp4"
                              type="video/mp4">
                          </video>
                        </router-link>
                      </swiper-slide>                
                      <!-- 바롬 페스티벌 알아보기-->
                      <swiper-slide class="sm:aspect-[200/241] overflow-y-hidden">
                        <router-link :to="'/list/barom1'">
                          <img src="@/assets/slide/main_slide1.jpg" class="w-full"/>
                          <div class="main_slide_text absolute bottom-3 left-0 text-white sm:p-10 p-5 pb-12">
                              <h3>바롬 Archive</h3>
                              <h1 class="underline decoration-1 underline-offset-8">바롬페스티벌<br/>알아보기</h1>
                          </div>
                        </router-link>
                      </swiper-slide>
                    </swiper-container>
                    <div class="swiper-button-prev"> </div>
                    <div class="swiper-button-next"> </div>
                </div>
            </section>

            <section class="sm:w-[44%]">
                <!-- pc -->
                <div class="main_pc_articles hidden sm:block h-full overflow-y-auto max-w-[357px] ml-auto mr-0 pr-2">
                    <article class="mb-12" v-for="item in bd1_list">
                        <div class="gall_tb relative overflow-hidden shadow-md">
                          <img :src="'http://swlife.dbconn.kr'+item.thumb+'?time='+item.uptodate" @click="viewPost(item.idx, 'bd1', item.secret);" class="w-full object-cover" :alt="item.title">
                          <!-- 유튜브 링크 -->
                          <a :href="item.youtube" target="_blank" class="gall_link absolute right-3 bottom-3" v-show="item.youtube">
                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
                              <circle cx="22" cy="22" r="22" style="fill: #ff856f;"/>
                              <path d="m25.45,22.76l-4.89,3.05c-.4.3-.96.22-1.26-.18-.13-.17-.19-.38-.18-.59v-6.1c-.02-.5.36-.92.85-.94.21-.01.42.05.59.18l4.89,3.05c.42.18.62.67.44,1.09-.08.2-.24.35-.44.44h0Zm4.22-10.29h-15.35c-2.11,0-3.82,1.7-3.84,3.81v11.44c.01,2.11,1.73,3.81,3.84,3.81h15.35c2.11,0,3.82-1.7,3.84-3.81v-11.44c-.01-2.11-1.73-3.81-3.84-3.81h0Z" style="fill: #fff; fill-rule: evenodd;"/>
                            </svg>
                          </a>
                        </div>
                        
                        <div class="board_list_lead grid justify-between mt-4">
                          <div class="gall_class">슈미션 활동</div>
                          <div class="flex truncate">
                            <img src="@/assets/img/lock.svg" class="w-5 mr-2" alt="비밀글" v-show="item.secret === 'Y'">
                            <h3 class="font-medium truncate" @click="viewPost(item.idx, 'bd1',item.secret);">{{item.title}}</h3>
                          </div>

                          <!-- 좋아요 -->
                          <a href="javascript:void(0)" class="gall_like flex gap-1">
                            <!-- 클릭 후 -->
                            <img src="@/assets/img/swu_heart.svg" v-if="listLikeCheck('bd1', item.idx) !== -1" />
                            <!-- 클릭 전 -->
                            <img src="@/assets/img/swu_heart_empty.svg" v-else />
                            <h3>{{item.like}}</h3>
                          </a>
                        </div>
                    </article>

                    <article class="mb-9" v-for="item in barom1_list">

                      <div class="gall_tb relative overflow-hidden shadow-md">
                        <img :src="'http://swlife.dbconn.kr'+item.thumb+'?time='+item.uptodate" @click="viewPost(item.idx, 'barom1',item.secret);" class="w-full object-cover" :alt="item.title">
                        <!-- 유튜브 링크 -->
                        <a :href="item.youtube" target="_blank" class="gall_link absolute right-3 bottom-3" v-show="item.youtube">
                          <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
                            <circle cx="22" cy="22" r="22" style="fill: #ff856f;"/>
                            <path d="m25.45,22.76l-4.89,3.05c-.4.3-.96.22-1.26-.18-.13-.17-.19-.38-.18-.59v-6.1c-.02-.5.36-.92.85-.94.21-.01.42.05.59.18l4.89,3.05c.42.18.62.67.44,1.09-.08.2-.24.35-.44.44h0Zm4.22-10.29h-15.35c-2.11,0-3.82,1.7-3.84,3.81v11.44c.01,2.11,1.73,3.81,3.84,3.81h15.35c2.11,0,3.82-1.7,3.84-3.81v-11.44c-.01-2.11-1.73-3.81-3.84-3.81h0Z" style="fill: #fff; fill-rule: evenodd;"/>
                          </svg>
                        </a>
                      </div>

                      <div class="board_list_lead grid justify-between mt-4">
                        <div class="gall_class">바롬페스티벌</div>
                        <h3 class="font-medium flex" @click="viewPost(item.idx, 'barom1', item.secret);">
                          <img src="@/assets/img/lock.svg" class="w-5 mr-2" alt="비밀글" v-show="item.secret === 'Y'">
                          {{item.title}}
                        </h3>

                        <!-- 좋아요 -->
                        <a href="javascript:void(0)" class="gall_like flex gap-1">
                          <!-- 클릭 후 -->
                          <img src="@/assets/img/swu_heart.svg" v-if="listLikeCheck('barom1', item.idx) !== -1" />
                          <!-- 클릭 전 -->
                          <img src="@/assets/img/swu_heart_empty.svg" v-else />
                          <h3>{{item.like}}</h3>
                        </a>
                      </div>

                    </article>

                </div>

                <!-- 모바일 -->
                <div class="main_mo_articles sm:hidden block overflow-x-hidden relative">
                  <div class="absolute top-[-5px] right-[-80px]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="315.49" height="62.7" viewBox="0 0 315.49 62.7">
                      <path d="m15.63,15.68c0-2.56,2.09-3.61,5.11-3.61,2.81,0,5.11,1.38,5.11,3.94v4.14h14.92v-5.98C40.77,4.12,31.76.5,20.74.5S.72,4.12.72,14.17v4.93c0,7.82,2.81,11.63,15.49,15.77,8.57,2.82,9.8,3.94,9.8,10.12v1.64c0,2.56-2.52,3.94-5.33,3.94s-5.26-1.38-5.26-3.94v-6.7H.5v8.61c0,10.05,9.01,13.67,20.03,13.67s20.39-3.61,20.39-13.67v-6.18c0-9.59-.94-12.94-15.85-18.2-7.64-2.69-9.44-3.61-9.44-6.04v-2.43ZM69,1.82l-5.91,39.42L58.19,1.82h-14.62l8.28,59.06h18.8l4.9-29.7,5.26,29.7h18.66L107.76,1.82h-14.19l-5.33,39.42L82.04,1.82h-13.04Zm67.06,44.55c0,2.56-2.02,3.94-4.83,3.94s-4.83-1.38-4.83-3.94V1.82h-15.2v46.71c0,10.05,9.01,13.67,20.03,13.67s20.03-3.61,20.03-13.67V1.82h-15.2v44.55ZM194.48,1.82h-15.85v59.06h35.73v-12.48h-19.88V1.82Zm23.12,0v59.06h15.85V1.82h-15.85Zm36.74,59.06v-24.17h19.88v-11.5h-19.88v-10.91h20.6V1.82h-35.74v59.06h15.13Zm60.65,0v-12.16h-21.32v-12.08h19.88v-11.5h-19.88v-11.17h20.6V1.82h-35.73v59.06h36.45,0Z" style="fill: #fff; fill-rule: evenodd; stroke: #e5e5e5; stroke-linejoin: round;"/>
                    </svg>
                  </div>

                  <!-- -->
                  <section class="mt-14 pl-8">
                    <div class="page_title_wrapper py-8">
                      <h1>우리들의 <span>이야기</span></h1>
                    </div>

                    <div class="main_list_wrapper flex gap-6 overflow-x-auto pr-5">

                      <article class="mb-9" v-for="item in bd1_list">
                        <div class="gall_tb relative overflow-hidden shadow-md">
                          <img :src="'http://swlife.dbconn.kr'+item.thumb+'?time='+item.uptodate" @click="viewPost(item.idx, 'bd1', item.secret);" class="w-full object-cover" alt="게시글 썸네일">

                          <a :href="item.youtube" target="_blank" class="gall_link absolute right-3 bottom-3" v-show="item.youtube">
                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
                              <circle cx="22" cy="22" r="22" style="fill: #ff856f;"/>
                              <path d="m25.45,22.76l-4.89,3.05c-.4.3-.96.22-1.26-.18-.13-.17-.19-.38-.18-.59v-6.1c-.02-.5.36-.92.85-.94.21-.01.42.05.59.18l4.89,3.05c.42.18.62.67.44,1.09-.08.2-.24.35-.44.44h0Zm4.22-10.29h-15.35c-2.11,0-3.82,1.7-3.84,3.81v11.44c.01,2.11,1.73,3.81,3.84,3.81h15.35c2.11,0,3.82-1.7,3.84-3.81v-11.44c-.01-2.11-1.73-3.81-3.84-3.81h0Z" style="fill: #fff; fill-rule: evenodd;"/>
                            </svg>
                          </a>
                        </div>
                        
                        <div class="board_list_lead grid justify-between mt-4">
                          <h3 class="font-medium flex" @click="viewPost(item.idx, 'bd1', item.secret);">
                            <img src="@/assets/img/lock.svg" class="w-5 mr-2" alt="비밀글" v-show="item.secret === 'Y'">
                            {{item.title}}
                          </h3>

                          <a href="javascript:void(0)" class="gall_like flex gap-1">
                            <img src="@/assets/img/swu_heart.svg" v-if="listLikeCheck('bd1', item.idx) !== -1" />
                            <img src="@/assets/img/swu_heart_empty.svg" v-else />
                            <h3>{{item.like}}</h3>
                          </a>
                        </div>
                      </article>
                    </div>

                    <div class="page_title_wrapper py-8">
                      <h1>바롬인성교육 <span class="alter">우수사례</span></h1>
                    </div>

                    <div class="main_list_wrapper flex gap-6 overflow-x-auto pr-5">
                      <article class="mb-9" v-for="item in barom1_list">
                        <div class="gall_tb relative overflow-hidden shadow-md">
                          <img :src="'http://swlife.dbconn.kr'+item.thumb+'?time='+item.uptodate" @click="viewPost(item.idx, 'barom1', item.secret);" class="w-full object-cover" alt="게시글 썸네일">

                          <a :href="item.youtube" target="_blank" class="gall_link absolute right-3 bottom-3" v-show="item.youtube">
                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
                              <circle cx="22" cy="22" r="22" style="fill: #ff856f;"/>
                              <path d="m25.45,22.76l-4.89,3.05c-.4.3-.96.22-1.26-.18-.13-.17-.19-.38-.18-.59v-6.1c-.02-.5.36-.92.85-.94.21-.01.42.05.59.18l4.89,3.05c.42.18.62.67.44,1.09-.08.2-.24.35-.44.44h0Zm4.22-10.29h-15.35c-2.11,0-3.82,1.7-3.84,3.81v11.44c.01,2.11,1.73,3.81,3.84,3.81h15.35c2.11,0,3.82-1.7,3.84-3.81v-11.44c-.01-2.11-1.73-3.81-3.84-3.81h0Z" style="fill: #fff; fill-rule: evenodd;"/>
                            </svg>
                          </a>
                        </div>
                        
                        <div class="board_list_lead grid justify-between mt-4">
                          <h3 class="font-medium flex" @click="viewPost(item.idx, 'barom1', item.secret);">
                            <img src="@/assets/img/lock.svg" class="w-5 mr-2" alt="비밀글" v-show="item.secret === 'Y'">
                            {{item.title}}
                          </h3>

                          <a href="javascript:void(0)" class="gall_like flex gap-1">
                            <img src="@/assets/img/swu_heart.svg" v-if="listLikeCheck('barom1', item.idx) !== -1" />
                            <img src="@/assets/img/swu_heart_empty.svg" v-else />
                            <h3>{{item.like}}</h3>
                          </a>
                        </div>
                      </article>

                    </div>

                  </section>

                  <div class="pl-5 mb-10">
                    <img src="@/assets/img/swu_main_mo.svg" alt="슈라이프는 서울여자대학교 바롬인성교육 사이트 입니다">
                  </div>
                </div>
            </section>
        </div>
    </div>
    <FooterComponent />

</template>

<script>
  import NavComponent from '@/components/NavComponent.vue'
  import FooterComponent from '@/components/FooterComponent.vue'
  
  import { register } from 'swiper/element/bundle';
  register();

  export default {
    name: 'GalleryRead',
    components: {
      NavComponent,
      FooterComponent,
    },
    data() {
      return {
        bd1_list: [],
        bd1_like: [],
        barom1_list: [],
        barom1_like: []
      }
    },
    methods: {
      set0() {
        const slideVid = document.getElementById('slideVid')
        slideVid.currentTime = 0;
      },
      getBoardLatest( board_id ){
        const me = this;
        const url = "/api/board.php";

        try {
          const formData = new FormData;
          formData.append('mode', 'getBoardLatest');
          formData.append('board_id', board_id);
          me.axios.post(url, formData, {
            headers: {
              'authorization2':localStorage.getItem('access_token')
            }
          }).then(function (res) {
            if( res.data.err === 0 ){
              me[`${board_id}_list`] = res.data.list;
              me[`${board_id}_like`] = res.data.like_list;
              console.log(me[`${board_id}_list`]);
            }
            else {
              console.log(res.data.err);
              // alert(res.data.err_msg);
              // me.$router.push({name: 'qna_list'});
              // return false;
            }
          })
        } catch (e) {
          console.log(e);
        }
      },
      viewPost( idx, board_id, secret ){
        if( secret === 'Y' ){
          this.postViewCheck(idx);
        }
        else {
          this.$router.push('/view/'+board_id+'/'+idx);
        }
      },

      postViewCheck(idx) {
        const me = this;
        const url = "/api/board.php";

        try {
          const formData = new FormData;
          formData.append('mode', 'postViewCheck');
          formData.append('bid', this.board_id);
          formData.append('pid', idx);
          me.axios.post(url, formData, {
            headers: {
              'authorization2':localStorage.getItem('access_token')
            }
          }).then(function (res) {
            if( res.data.err === 0 ){
              if( res.data.viewPower === 1 ){
                me.$router.push('/view/'+me.board_id+'/'+idx);
              }
              else {
                alert('해당 글을 읽을 수 없습니다.');
                return false;
              }
            }
            else {
              // const err_msg = `[${res.data.err}] ${res.data.err_msg}`;
              // alert(err_msg);
              // return false;
            }
          })
        } catch (e) {
          console.log(e);
        }
      },
      listLikeCheck( board_id, idx ) {
        return this[`${board_id}_like`].indexOf(idx);
      }

  	},
    mounted() {
      this.getBoardLatest('bd1');
      this.getBoardLatest('barom1');
    }

  }
</script>
